import { FC } from "react";
import { cn } from "@design-system";

// Reusable settings row component for consistent alignment
export interface SettingsRowProps {
  title: string;
  description: string;
  children: React.ReactNode;
  separator?: boolean;
}

export const SettingsRow: FC<SettingsRowProps> = ({ 
  title, 
  description, 
  children, 
  separator = true 
}) => {
  return (
    <div className={cn("py-3", separator && "border-b border-border")}>
      <div className="flex items-center justify-between">
        <div className="flex-1 pr-6">
          <h3 className="text-base font-medium text-text">
            {title}
          </h3>
          <p className="text-sm text-muted mt-1">
            {description}
          </p>
        </div>
        <div className="flex-shrink-0">
          {children}
        </div>
      </div>
    </div>
  );
}; 